import React, { ReactChild, useState, useEffect, useContext } from 'react';
import { IComponentContact } from '../../component.d';
import './Contact.scss';

import { ThemeContext } from '../../store/ThemeProvider';
import intl from 'react-intl-universal';
import { getPendantColor } from '../../utils/color';
import chroma from 'chroma-js';
import ReactSVG from 'react-svg';
import BottomModal from '../ButtonGroup/BottomModal';
import { getNameByType } from '../ButtonGroup/AllForButtonGroup';
import { style } from '../../utils/image';
import moment from 'moment';
import stat from '../../utils/stat';

const ContactList = (props: {
  contacts: any[];
  h1Color: any;
  h2Color: any;
}) => {
  const { contacts, h1Color, h2Color } = props;

  const [showItem, setShowItem] = useState(null as any);

  return (
    <div className="contact-modal-list">
      {(contacts || []).map((it: any) => {
        if (it && it.cid) {
          return (
            <div key={it.cid} className="contact-list-item">
              <div className="userinfo">
                {it.avatar ? (
                  <img
                    src={style(it.avatar, 'avatar_150')}
                    className="avatar"
                  />
                ) : null}
                <div className="names">
                  <div className="name" style={{ color: h1Color }}>
                    {it.name}
                  </div>
                  <div className="level" style={{ color: h2Color }}>
                    {it.level}
                  </div>
                </div>
              </div>
              {it.phone || it.qrcode ? (
                <div className="contactinfo">
                  {it.qrcode ? (
                    <a
                      className="contact-item"
                      onClick={() => {
                        setShowItem(it);

                        stat.event('contact_wx');
                      }}
                    >
                      <img src={require('../../assets/contact_wechat.png')} />
                      <span style={{ color: h1Color }}>
                        {intl.get('Wechat')}
                      </span>
                    </a>
                  ) : null}
                  {it.phone ? (
                    <a
                      href={`tel:${it.phone}`}
                      className="contact-item"
                      onClick={() => {
                        stat.event('contact_phone');
                      }}
                    >
                      <img src={require('../../assets/contact_phone.png')} />
                      <span style={{ color: h1Color }}>
                        {intl.get('Phone')}
                      </span>
                    </a>
                  ) : null}
                </div>
              ) : (
                <div />
              )}
            </div>
          );
        }
      })}

      {showItem ? (
        <div className="wechat-dialog">
          <a className="close" onClick={() => setShowItem(null)}>
            <img src={require('../../assets/x-36.png')} />
          </a>
          <div className="wechat-wrapper">
            <img
              src={style(showItem.qrcode, 'avatar_150')}
              className="qrcode"
            />
            <div className="qrcode-infos">
              <div className="qrcode-name">{showItem.name}</div>
              <div className="qrcode-level">{showItem.level}</div>
              <div className="border"></div>
              <div className="qrcode-tip">{intl.get('WechatTips')}</div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default (props: IComponentContact) => {
  const { title, contacts } = props;
  const { componentColor, mainColor, h1Color, h2Color } = useContext(
    ThemeContext
  );

  const [modalTitle, setModalTitle] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalChild, setModalChild] = useState('' as ReactChild);

  const showContactDialog = () => {
    setModalTitle(title == '立即咨询' ? intl.get('ContactNow') : title);
    setShowModal(true);
    let childContent = '' as ReactChild;
    childContent = (
      <ContactList contacts={contacts} h1Color={h1Color} h2Color={h2Color} />
    );

    setModalChild(childContent);
  };

  const [bgColor, foreColor] = getPendantColor(mainColor);

  return (
    <div className="component-contact">
      <div
        className="contact-button"
        style={{ background: mainColor, color: foreColor }}
        onClick={showContactDialog}
      >
        {title == '立即咨询' ? intl.get('ContactNow') : title}
      </div>

      <BottomModal
        title={modalTitle}
        show={showModal}
        onHide={() => setShowModal(false)}
        child={modalChild}
      />
    </div>
  );
};
